import { api } from "./api";

export async function startCheckout(payload) {
  const { data } = await api.post("/payments/checkout", {
    ...payload,
    origin_url: window.location.origin,
  });
  if (data.url) {
    window.location.href = data.url;
    return data;
  }
  throw new Error("No checkout URL received");
}

export async function getPaymentStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
}

export async function getPricing() {
  const { data } = await api.get("/payments/pricing");
  return data;
}
